import {
  Component, OnInit
} from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from '../../../shared/services/data.service';
import { VchrprintComponent } from "../../component/vchrprint/vchrprint.component";
import { InProductsService } from "../../services/inventory/in-products.service";
import { environment } from "../../../../environments/environment";

export interface EditModel {
  title: string;
  Barcode: any;
}
@Component({
  selector: 'app-sellingprice-edit',
  templateUrl: './sellingprice-edit.component.html',
  styleUrls: ['./sellingprice-edit.component.css']
})

export class SellingPriceEditComponent extends DialogComponent<EditModel, boolean> 
 implements EditModel, OnInit {

  title: string;
  Barcode: string ;

  result: any = { result: false, RtnItem: {} };

  UpdateSelPricePrntEnable:boolean=false;
  PriceChangeUpdate:boolean=false;
  Access:any;
  EnableSave:boolean=true;
  Cols:any;
  Items:PriceChange_Master[]=[];

  constructor(dialogService: DialogService, private ds: DataService,private pds: InProductsService) { super(dialogService); }

  ngOnInit() {
    this.Access = this.ds.Access["Price Updation"];
    this.EnableSave=this.Access.save;
    var iw = (this.ds.Settings.PriceChangeUpdate)
    this.PriceChangeUpdate = iw.toLowerCase() == 'true'
    var iw = (this.ds.Settings.UpdateSelPricePrntEnable)
    this.UpdateSelPricePrntEnable = iw.toLowerCase() == 'true'
    this.Cols=this.LoadCols();
    this.LoadSellingPrice();
  }
  LoadCols(){
    var col = [
      { field: 'Barcode', header: 'Barcode', t: 'text', e: false },
      { field: 'SellingPriceLevelName', header: 'Selling Price Level Name', t: 'text', e: false },
      { field: 'OldPrice', header: 'Old Price', t: 'decimal', e: false },
      { field: 'NewPrice', header: 'New Price', t: 'decimal', e: true }
    ]
    return col;
  }

  

  LoadSellingPrice(){
  
    var data={
      Barcode:this.Barcode,
      Id:1
    }
    this.pds.Get_SellingPriceDetailsForEdit(data).subscribe(res => {
      if (res.Success) {
        this.Items=res.data;
      }
      else{
       this.Items=[];
      }
    })

  }

  Update(){
    if(this.Items.length>0){
      for(let i of this.Items){
        i.UserId=this.ds.Settings.UserId;
        i.CompanyId=this.ds.Settings.CompanyId;
        i.BranchId=this.ds.Settings.BranchId;
        i.PriceChangeUpdate=this.PriceChangeUpdate;
      }
      this.pds.Update_SellingPriceFromProduct(this.Items).subscribe(res => {
        if (res.Success) {
          this.Items=res.data;
          if(this.PriceChangeUpdate){
            alert("Price updated Successfully");
            if(this.UpdateSelPricePrntEnable){
              this.print();
            }
          }      
        }
        else {
          alert(res.error.UsrMsg);
         // this.loading = false;
        }
      });
  
      this.result.result = true;
      this.result.RtnItem = this.Items;
      this.close();
    }
    
  }

  print(){
    var pid = '';
    for (let i of this.Items) {
        pid = pid + i.PriceLogId.toString() + ",";
    }
    pid = pid.replace(/,\s*$/, "");
    var t = "Price Change Report";
    var url = environment.reportUrl;
    var Path = "POS/PriceChangeLoginv";
    var param = { branchid: this.ds.Settings.BranchId, companyid: this.ds.Settings.CompanyId, id: pid, locationid: this.ds.Settings.LocationId };
    let d = this.dialogService
      .addDialog(VchrprintComponent, {
        title: t,
        reportServerUrl: url,
        reportPath: Path,
        parametersList: param
      })
      .subscribe(res => {
        if (res.result) {
        }
      });
  }



}
class PriceChange_Master{
   SellingPriceMasterId : number
   Barcode : string
   SellingPriceLevelName : string
   SellingPriceLevelId : number
   OldPrice : number = 0
   NewPrice : number = 0
   UserId : number = 0
   CompanyId : number = 0
   BranchId : number = 0
   PriceChangeUpdate : boolean = false
   PriceLogId : string = ""
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/sellingprice-edit/sellingprice-edit.component.ts